import { RelatedEntityField } from '@shared/data/entity/fields/RelatedEntityField';
import { getEntityTitle } from '@shared/data/entity/getEntityTitle';
import { notNil } from '@shared/util/notNil';

/**
 * A related card field as one line of text: the first card's title, and a "+N" for any more, in
 * the field's own order (the order its pills show), skipping cards the refs don't hold.
 */
export function getRelatedCardText(field: RelatedEntityField): string {
  const [first = '', ...more] = field.items
    .map(item => field.relatedEntities.find(relatedEntity => relatedEntity.id === item.id))
    .filter(notNil)
    .map(entity => getRelatedCardTitle(field, entity));
  return more.length > 0 ? `${first} +${more.length}` : first;
}

/**
 * A related card's title, or for a card without one, its template's name, so a card counts and
 * reads the same in every variant.
 */
export function getRelatedCardTitle(
  field: RelatedEntityField,
  entity: RelatedEntityField['relatedEntities'][number],
): string {
  const workflowTemplate = field.workflowTemplateRefs?.find(
    template => template.id === entity.workflowTemplateId,
  );
  return getEntityTitle(entity, workflowTemplate) ?? workflowTemplate?.name ?? '';
}
